import React from "react";
import { StyledColGroup } from "./styles";

type ColGroupProps = {
  numCols: number;
  numRows: number;
};

const ColGroup: React.FC<ColGroupProps> = ({ numCols, numRows }) => (
  <StyledColGroup $numRows={numRows}>
    {Array.from({ length: numCols }, (_, index) => (
      <col key={index} />
    ))}
  </StyledColGroup>
);

export default ColGroup;
